import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "@/config/firebase";
import { useAuthStore } from "@/store/authStore";
import type { SyncConfig } from "@/services/syncService";

/**
 * Live cloud sync configuration/progress (cloudSync/{uid}, written by the
 * export-worker). null = sync never enabled.
 */
export function useCloudSync(): { config: SyncConfig | null; loading: boolean } {
  const { user } = useAuthStore();
  const [config, setConfig] = useState<SyncConfig | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.uid) {
      setConfig(null);
      setLoading(false);
      return;
    }
    const unsubscribe = onSnapshot(
      doc(db, `cloudSync/${user.uid}`),
      (snapshot) => {
        setConfig(snapshot.exists() ? (snapshot.data() as SyncConfig) : null);
        setLoading(false);
      },
      () => setLoading(false)
    );
    return () => unsubscribe();
  }, [user?.uid]);

  return { config, loading };
}

